import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { userGetCertification } from 'Api/courseDetailsCertification';

const useCertificate = (courseId, setIsLoading) => {
  const [certification, setCertification] = useState();
  const { id, fullName } = useSelector(userSelector);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      userGetCertification({ courseId, userId: id }).then(data => {
        if (data !== undefined) {
          setCertification(data);
          setIsLoading(false);
        }
      });
    }

    return () => {
      isMounted = false;
      setCertification(null);
    };
  }, [courseId]);

  return {
    userName: fullName,
    certification,
  };
};

export default useCertificate;
